<template>
  <div>
    <label for="language-select">
      <font-awesome-icon class="globe-icon" :icon="['fas', 'globe-americas']" />
    </label>
    <select
      class="form-control"
      id="language-select"
      v-model="selected"
      @change="handleSelectedLanguage(selected)"
    >
      <option v-for="(option, id) in options" :key="id">
        {{ option.value }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "LanguageSelector",
  data() {
    return {
      options: [
        { text: "English", value: "EN" },
        { text: "Spanish", value: "ES" },
        { text: "Portuguese", value: "PT" },
      ],
      selected: "PT",
    };
  },
  methods: {
    handleSelectedLanguage(value) {
      this.selected = value;
      if (value === "EN") window.location = "https://us.liberfly.net";
      if (value === "PT") window.location = "https://liberfly.pt";
      if (value === "ES") window.location = "https://liberfly.es";
    },
  },
};
</script>

<style lang="scss" scoped>
select {
  padding: 0.7em;
  background: none;
  border: none;
  outline: 0;
  font-weight: $thin;
  color: $white-secondary;
}

select.form-control {
  color: $white-secondary;
  background: $blue-primary;
  border: none;
  outline: none;
}

.globe-icon {
  margin-left: 0.3em;
  color: $white-secondary;
}
</style>
